import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'ue-audi',
    title: 'Audi Configurator with Pixel Streaming',
    description: 'A virtual car configurator using Unreal Engine 5 and Pixel Streaming. Configure your dream Audi car in real-time.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
    },
};

export default data;
